import {
    ApiDialogActionType,
    ApiDialogAudienceType,
    ApiDialogOptionType,
    ApiDialogStatus,
} from '@/core/generated/api';

/** Обработчики диалоговых окон */
export const DIALOG_ACTION_OPTIONS = [
    {
        id: ApiDialogActionType.Acknowledge,
        name: 'Подтвердить прочтение'
    },
    {
        id: ApiDialogActionType.RecordAnswer,
        name: 'Записать ответ'
    },
    {
        id: ApiDialogActionType.CollectFeedback,
        name: 'Собрать обратную связь'
    },
    {
        id: ApiDialogActionType.OrderSearch,
        name: 'Поиск исполнителя'
    },
    {
        id: ApiDialogActionType.FavoriteOrderSearch,
        name: 'Поиск любимых исполнителей'
    },
];

/** Сохраняемые значения кнопок */
export const DIALOG_ANSWER_OPTIONS = [
    {
        id: ApiDialogOptionType.Continue,
        name: 'Продолжить / Понятно'
    },
    {
        id: ApiDialogOptionType.Yes,
        name: 'Да'
    },
    {
        id: ApiDialogOptionType.No,
        name: 'Нет'
    },
    {
        id: ApiDialogOptionType.Cancel,
        name: 'Отменить'
    },
    {
        id: ApiDialogOptionType.Skip,
        name: 'Пропустить'
    },
];

/** Аудитории выпуска */
export const DIALOG_AUDIENCE_OPTIONS = [
    {
        id: ApiDialogAudienceType.All,
        name: 'Клиенты и исполнители'
    },
    {
        id: ApiDialogAudienceType.Clients,
        name: 'Клиенты'
    },
    {
        id: ApiDialogAudienceType.Executors,
        name: 'Исполнители'
    },
];

/** Подписи статусов назначений */
export const DIALOG_STATUS_NAMES: Record<ApiDialogStatus, string> = {
    [ApiDialogStatus.Undefined]: 'Не определён',
    [ApiDialogStatus.Pending]: 'Ожидает ответа',
    [ApiDialogStatus.Answered]: 'Ответ получен',
    [ApiDialogStatus.Expired]: 'Срок истёк',
    [ApiDialogStatus.Cancelled]: 'Отменён',
    [ApiDialogStatus.Read]: 'Прочитан',
};
